export function showToggle() {
	document.addEventListener("DOMContentLoaded", () => {
		const toggleElements = document.querySelectorAll(".show-toggle");
		const showMoreString = translation.toggle_show_more;
		const showLessString = translation.toggle_show_less;
		//console.log(showMoreString);
		
		toggleElements.forEach((originalEl) => {
			// Wrap content in a new structure
			const wrapper = document.createElement("div");
			wrapper.className = "show-toggle-wrapper collapsed";
	
			const fade = document.createElement("div");
			fade.className = "fade-gradient";
	
			const button = document.createElement("button");
			button.className = "toggle-button";
			button.textContent = showMoreString;
	
			// Move the original content into the wrapper
			const content = originalEl.cloneNode(true);
			wrapper.appendChild(content);
			wrapper.appendChild(fade);
	
			// Replace the original element
			originalEl.replaceWith(wrapper);
			wrapper.insertAdjacentElement("afterend", button);
	
			// Toggle behavior
			button.addEventListener("click", () => {
				const isCollapsed = wrapper.classList.contains("collapsed");
				wrapper.classList.toggle("collapsed", !isCollapsed);
				wrapper.classList.toggle("expanded", isCollapsed);
				button.textContent = isCollapsed ? showLessString : showMoreString;
			});
		});
	});
}
